import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Toyotaetiononrentinmumbai() {



    const cardData = {





keyword: "Toyota Etios on Rent in Mumbai",

headingDescription: "Shreesha Tours & Travels offers reliable and affordable Toyota Etios on Rent in Mumbai for airport transfers, local travel, corporate transportation, outstation trips, business meetings, family vacations, railway station transfers, sightseeing tours, one-way journeys, and round-trip travel across India. The Toyota Etios is a comfortable and fuel-efficient sedan, well-known for its spacious interiors, smooth ride quality, excellent mileage, and generous luggage space, making it an ideal choice for business executives, families, couples, and solo travelers. Our chauffeur-driven Toyota Etios rental service includes experienced drivers, clean and well-maintained vehicles, doorstep pickup, transparent pricing, flexible travel packages, and 24/7 customer support. Whether you are planning a weekend getaway, corporate tour, pilgrimage, destination wedding, or long-distance road trip from Mumbai, Shreesha Tours & Travels ensures a safe, comfortable, economical, and hassle-free travel experience with dependable service and punctual transportation.",

topPlaces: [
  {
    title: "Mumbai to Silvassa",
    description: "Silvassa is a peaceful destination known for lush gardens, tribal culture, wildlife parks, and scenic surroundings. It is a popular weekend getaway for families and couples looking for a relaxing road trip."
  },
  {
    title: "Mumbai to Jawhar",
    description: "Jawhar is a beautiful hill station in Maharashtra famous for Jai Vilas Palace, Dabhosa Waterfall, Hanuman Point, and serene natural beauty. Toyota Etios is a comfortable choice for this scenic journey."
  },
  {
    title: "Mumbai to Trimbakeshwar",
    description: "Trimbakeshwar is one of the twelve sacred Jyotirlingas and a major pilgrimage destination near Nashik. Families and devotees frequently hire Etios cabs for a peaceful spiritual journey."
  },
  {
    title: "Mumbai to Kaas Plateau",
    description: "Kaas Plateau is a UNESCO World Natural Heritage Site celebrated for its seasonal wildflowers and breathtaking landscapes. It is a favorite destination for nature lovers and photography enthusiasts."
  },
  {
    title: "Mumbai to Diu",
    description: "Diu is known for its pristine beaches, Portuguese forts, churches, and peaceful coastal atmosphere. It is an excellent destination for a comfortable long-distance holiday."
  },
  {
    title: "Mumbai to Vadodara",
    description: "Vadodara is a vibrant city famous for Laxmi Vilas Palace, Sayaji Gardens, museums, universities, and industrial development. It is frequently visited for both business and leisure travel."
  },
  {
    title: "Mumbai to Kutch",
    description: "Kutch is renowned for the spectacular White Rann, handicrafts, desert festivals, and rich Gujarati culture. Toyota Etios offers an economical option for long-distance road journeys."
  },
  {
    title: "Mumbai to Aurangabad",
    description: "Aurangabad is famous for the Ajanta and Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and historical monuments. It is one of the best destinations for heritage tourism."
  },
  {
    title: "Mumbai to Nagpur",
    description: "Nagpur is known as the Orange City of India and is famous for Deekshabhoomi, Futala Lake, wildlife sanctuaries, and business centers. It is a preferred route for corporate and family travel."
  },
  {
    title: "Mumbai to Udaipur",
    description: "Udaipur, the City of Lakes, is renowned for City Palace, Lake Pichola, Fateh Sagar Lake, and royal heritage. It is a popular destination for luxury vacations, honeymoon trips, and heritage tours."
  }
],



"services": [
  {
    "name": "Toyota Etios on Rent in Mumbai",
    "description": "Book Toyota Etios on Rent in Mumbai for economical, comfortable, and reliable chauffeur-driven travel with professional drivers and well-maintained AC sedan cars. Toyota Etios is an excellent choice for airport transfers, business travel, local city rides, family outings, sightseeing, hotel transfers, and outstation journeys with flexible one way and round trip booking options."
  },
  {
    "name": "Etios Car Rental Mumbai",
    "description": "Choose Etios Car Rental Mumbai for affordable and comfortable transportation with clean AC vehicles, experienced chauffeurs, and transparent pricing. Our Etios rental service is ideal for family travel, corporate meetings, airport pickup and drop, sightseeing tours, and interstate travel across Maharashtra and nearby states."
  },
  {
    "name": "Toyota Etios Cab Mumbai",
    "description": "Hire Toyota Etios Cab Mumbai for smooth and hassle-free travel with spacious sedan seating, professional drivers, and reliable service. Perfect for daily travel, office commutes, airport transfers, business visits, personal trips, and long-distance outstation journeys."
  },
  {
    "name": "Etios Taxi Service Mumbai",
    "description": "Book Etios Taxi Service Mumbai for dependable transportation with courteous chauffeurs, clean vehicles, and affordable fares. Enjoy safe travel for family functions, corporate events, local sightseeing, airport transfers, and one way or round trip travel."
  },
  {
    "name": "Etios Hire Mumbai",
    "description": "Choose Etios Hire Mumbai for convenient chauffeur-driven travel with flexible booking options and comfortable sedan vehicles. Our Etios cars are suitable for weddings, business travel, family vacations, city tours, hotel transfers, and outstation travel."
  },
  {
    "name": "Etios Car Hire Mumbai",
    "description": "Reserve Etios Car Hire Mumbai for premium travel with experienced drivers, spacious interiors, and affordable rental packages. Enjoy comfortable transportation for personal trips, corporate travel, airport transfers, sightseeing, and long-distance journeys."
  },
  {
    "name": "Etios with Driver Mumbai",
    "description": "Book Etios with Driver Mumbai for stress-free transportation with trained chauffeurs, comfortable AC cars, and professional service. Ideal for business meetings, airport pickup and drop, family outings, weekend trips, and interstate travel."
  },
  {
    "name": "Etios Outstation Cab Mumbai",
    "description": "Hire Etios Outstation Cab Mumbai for comfortable one way and round trip travel to destinations across Maharashtra, Goa, Gujarat, Karnataka, and other cities. Enjoy smooth highway travel with experienced drivers, transparent pricing, and reliable customer support."
  },
  {
    "name": "Etios Airport Taxi Mumbai",
    "description": "Choose Etios Airport Taxi Mumbai for timely airport pickup and drop services with flight monitoring, luggage assistance, and professional chauffeurs. Travel comfortably to and from Mumbai Airport with reliable sedan cab services available 24x7."
  },
  {
    "name": "Etios Corporate Cab Mumbai",
    "description": "Book Etios Corporate Cab Mumbai for executive transportation, office travel, airport transfers, employee movement, conferences, and client meetings. Our professional chauffeurs ensure punctual, safe, and comfortable travel for every business requirement."
  },
  {
    "name": "Etios Sedan Rental Mumbai",
    "description": "Reserve Etios Sedan Rental Mumbai for economical and comfortable chauffeur-driven travel with spacious seating, clean interiors, and modern amenities. Suitable for family vacations, corporate travel, sightseeing, hotel transfers, and outstation journeys."
  },
  {
    "name": "Etios One Way Cab Mumbai",
    "description": "Choose Etios One Way Cab Mumbai for affordable single-trip travel without return fare charges. Enjoy fixed pricing, comfortable AC sedan cars, experienced drivers, and convenient pickup services for airport transfers, business travel, and intercity journeys."
  },
  {
    "name": "Etios Round Trip Taxi Mumbai",
    "description": "Book Etios Round Trip Taxi Mumbai for convenient return journeys with affordable travel packages, flexible schedules, and dependable chauffeur service. Perfect for family holidays, business tours, sightseeing, pilgrimages, and weekend getaways."
  },
  {
    "name": "Best Toyota Etios Rental Mumbai",
    "description": "Choose the Best Toyota Etios Rental Mumbai for premium chauffeur-driven transportation with well-maintained AC vehicles, courteous drivers, competitive pricing, and outstanding customer support. Whether you need airport transfers, local travel, corporate transportation, family trips, sightseeing tours, or outstation cab services, our Toyota Etios rental ensures a safe, comfortable, and budget-friendly travel experience every time."
  }
],
"tableData": [
  ["Toyota Etios on Rent in Mumbai", "Etios Car Rental Mumbai"],
  ["Toyota Etios Cab Mumbai", "Etios Taxi Service Mumbai"],
  ["Etios Hire Mumbai", "Etios Car Hire Mumbai"],
  ["Etios with Driver Mumbai", "Etios Outstation Cab Mumbai"],
  ["Etios Airport Taxi Mumbai", "Etios Corporate Cab Mumbai"],
  ["Etios Sedan Rental Mumbai", "Etios One Way Cab Mumbai"],
  ["Etios Round Trip Taxi Mumbai", "Best Toyota Etios Rental Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Affordable Toyota Etios on Rent in Mumbai",
    WhyChoosedescription: "Choose Shreesha Travels for Toyota Etios rental in Mumbai and enjoy comfortable, economical, and dependable transportation. The Toyota Etios is a preferred sedan for airport transfers, corporate travel, local city rides, sightseeing tours, and outstation journeys."
  },
  {
    WhyChooseheading: "Reliable Sedan for Daily & Long-Distance Travel",
    WhyChoosedescription: "Known for its spacious cabin, smooth performance, and fuel efficiency, the Toyota Etios is an excellent option for business executives, families, tourists, and individual travellers seeking a comfortable road journey."
  },
  {
    WhyChooseheading: "Travel Beyond Mumbai with Complete Convenience",
    WhyChoosedescription: "Hire a Toyota Etios for trips to Pune, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Surat, Ahmedabad, Indore, Jaipur, Bengaluru, Kolhapur, and many other destinations across India."
  },
  {
    WhyChooseheading: "Ideal for Airport, Corporate & Hotel Transfers",
    WhyChoosedescription: "Our Toyota Etios rental service is suitable for airport pickups, hotel transfers, executive travel, client meetings, conferences, medical visits, and personal transportation with professional chauffeur service."
  },
  {
    WhyChooseheading: "Flexible Rental Packages for Every Requirement",
    WhyChoosedescription: "Book one-way taxis, round-trip journeys, airport transfers, full-day rentals, multi-day road trips, or customized travel packages that suit your itinerary and travel schedule."
  },
  {
    WhyChooseheading: "Professional Chauffeurs with Excellent Route Knowledge",
    WhyChoosedescription: "Experienced drivers ensure timely pickups, safe driving, efficient navigation, and courteous assistance throughout your journey in Mumbai and beyond."
  },
  {
    WhyChooseheading: "Clean, Comfortable & Well-Serviced Toyota Etios",
    WhyChoosedescription: "Each Toyota Etios undergoes routine servicing, interior cleaning, sanitization, and quality inspections to deliver a reliable and pleasant travel experience."
  },
  {
    WhyChooseheading: "Book Your Toyota Etios with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, prompt customer support, and dependable chauffeur-driven Toyota Etios rentals for business, leisure, and outstation travel."
  }
]

};

const faqData = [
  {
    question: "Why is the Toyota Etios a good rental option in Mumbai?",
    answer: "The Toyota Etios is valued for its comfortable seating, spacious interiors, reliable performance, and fuel efficiency, making it suitable for both city and outstation travel."
  },
  {
    question: "How many passengers can travel in a Toyota Etios?",
    answer: "The Toyota Etios comfortably accommodates up to four passengers along with their luggage."
  },
  {
    question: "Can I rent a Toyota Etios for outstation travel?",
    answer: "Yes, Toyota Etios rentals are available for one-way trips, round trips, holiday tours, business travel, and long-distance road journeys."
  },
  {
    question: "Do you provide Toyota Etios for airport transfers?",
    answer: "Yes, chauffeur-driven Toyota Etios cars are available for Mumbai Airport pickups and drop-offs at both domestic and international terminals."
  },
  {
    question: "Is the Toyota Etios suitable for corporate travel?",
    answer: "Yes, it is widely used for executive transportation, office meetings, client visits, conferences, and official travel."
  },
  {
    question: "Can I book the Toyota Etios for a full-day rental?",
    answer: "Yes, we offer hourly rentals, full-day bookings, and customized travel packages according to your schedule."
  },
  {
    question: "Are advance bookings available?",
    answer: "Yes, advance reservations are recommended to ensure vehicle availability during weekends, holidays, and peak travel seasons."
  },
  {
    question: "How is the Toyota Etios rental fare calculated?",
    answer: "The fare depends on the selected travel package, total distance, trip duration, destination, and any additional travel requirements."
  },
  {
    question: "Can I customize my travel itinerary?",
    answer: "Yes, we can arrange personalized itineraries with multiple destinations, sightseeing stops, and overnight stays based on your requirements."
  },
  {
    question: "How can I book a Toyota Etios on Rent in Mumbai with Shreesha Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger details, and itinerary to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Bhatia",
    feedback: "The Toyota Etios delivered a smooth and comfortable ride throughout the journey. Professional service, punctual timing, and a well-maintained vehicle made the experience completely satisfying.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Kulkarni",
    feedback: "The entire trip was managed efficiently from start to finish. Comfortable seating, courteous assistance, and reliable transportation made travelling both convenient and enjoyable.",
    rating: 5
  }
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Toyota Etios on Rent in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/toyota-etios-on-rent-in-mumbai.webp",
  "description":
    "Book Toyota Etios on Rent in Mumbai with Shreesha Tours & Travels for reliable, comfortable, and affordable chauffeur-driven sedan rental services. We provide Toyota Etios cabs available 24x7 for airport transfers, local travel, corporate trips, business meetings, family journeys, and outstation travel with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/toyota-etios-on-rent-in-mumbai"
  }
};



    return (
        <div>
<Helmet>
  <title>Toyota Etios on Rent in Mumbai | Sedan Cab Rental | +91 8355835813</title>

  <meta
    name="description"
    content="Book Toyota Etios on Rent in Mumbai with Shreesha Travels for affordable sedan cab rental services. Hire Toyota Etios with driver for airport transfers, local rides, corporate travel, and outstation trips with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Toyota Etios on Rent in Mumbai, Etios Car Rental Mumbai, Toyota Etios Cab Mumbai, Etios Taxi Service Mumbai, Etios Hire Mumbai, Etios Car Hire Mumbai, Etios with Driver Mumbai, Etios Outstation Cab Mumbai, Etios Airport Taxi Mumbai, Toyota Etios Rental Service Mumbai, Sedan Cab Rental Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Toyotaetiononrentinmumbai;